<template>
    <div class="order bg_white">
        <div class="header">
            <div class="filter">
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">开始时间：</span>
                    <DatePicker type="datetimerange" @on-change="dateChange" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" style="width: 285px"></DatePicker>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">点位：</span>
                    <selection class="select fl" :options="points" @change="pointChange"></selection>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">状态：</span>
                    <selection class="select fl" :options="$config.orderStatus.getItem(2)"  @change="statusChange"></selection>
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">订单编号：</span>
                    <input type="text" @blur="orderNoChange" />
                </div>
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">电话号码：</span>
                    <input type="text" @blur="phoneChange" />
                </div>
            </div>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @detailEvent="detailEvent"
               @releaseEvent="releaseEvent" @refundEvent="refundEvent" @forceFinishEvent="forceFinishEvent"></lists>
    </div>
</template>
<!--

-->
<script>
    import Lists from '@/components/Lists'
    import {mapGetters} from "vuex";

    export default {
        name: "order",
        components: {
            Lists
        },
        data() {
            return {
                points: [],
                filter: {},
                lists: {
                    title: [{text: '订单编号'}, {text: '订单开始时间'}, {text: '预约结束时间'}, {text: '订单结束时间'},{text: '使用时长'}, {text: '支付金额'},
                        {text: '点位名称'}, {text: '柜门'}, {text: '手机号'}, {text: '状态'}, {text: '密码'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '12%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '11%', textAlign: 'left'},
                    {width: '6%', textAlign: 'center'},
                    {width: '6%', textAlign: 'center'},
                    {width: '9%', textAlign: 'left'},
                    {width: '6%', textAlign: 'left'},

                    {width: '8%', textAlign: 'left'},
                    {width: '4%', textAlign: 'left'},
                    {width: '6%', textAlign: 'left'},
                    {width: '10%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/order',
                    func: this.httpRequestHandle,
                    error: '获取订单信息出错',
                    auto: false
                }
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
                this.getPoints();
            },
            getPoints() {
                this.$api.get('/manage/point').then((res) => {
                    this.points = res.data.map(item => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取点位列表失败'});
                });
            },
            pointChange(data) {
                this.filter.point_id = !data ? '' : data.id;
                this.$refs.lists.updateData(this.filter);
            },
            statusChange(data) {
                this.filter.status = !data ? '' : data.id;
                this.$refs.lists.updateData(this.filter);
            },
            orderNoChange(event) {
                this.filter.order_no = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            phoneChange(event) {
                this.filter.phone = event.target.value || '';
                this.$refs.lists.updateData(this.filter);
            },
            dateChange(date) {
                this.filter.time_start = date[0];
                this.filter.time_end = date[1];
                this.$refs.lists.updateData(this.filter);
            },
            httpRequestHandle(data) {
                return data.map(item =>{
                    let operation = {arr: []};
                    if(item.status === 2) {
                        operation.arr.push({text: '释放柜门', style: {color: '#1890FF'}, event: 'releaseEvent'});
                    }
                    if(this.role === 'admin' && (item.status === 2 || item.status === 5) ){
                        operation.arr.push({text: '强制完成', style: {color: '#1890FF'}, event: 'forceFinishEvent'});
                    }
                    if(operation.arr.length === 0){
                        operation = {text: '-----'};
                    }
                    return [
                        {text: item.order_no},
                        {text: item.time_start},
                        {text: item.time_end},
                        {text: item.status !== 0 ? item.finish_time : '-----'},
                        {text: item.time_use},
                        {text: item.paid},
                        {text: item.equipment_name},
                        {text: item.door_no + '号柜'},
                        {text: item.phone},
                        {text: this.$config.orderStatus.get(item.status)},
                        {text: item.password},
                        operation
                    ]
                });
            },
            detailEvent() {
                this.$modal({content: '暂时未开放该功能'});
            },
            forceFinishEvent(data) {
                this.$modal({
                    content: '确认是否是超时或者冻结订单，此操作将更改状态，不可撤销',
                    confirm: ()=>{
                        this.$api.get('/manage/order_status/' + data.id,).then((data) => {
                            this.$alert.success({content: '强制完成成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '强制完成失败：' + error});
                        });
                    }
                });
            },
            refundEvent(data) {
                this.$modal({
                    content: '确认退款，此操作不可撤销',
                    confirm: ()=>{
                        this.$api.put('/manage/refund/' + data.id,{
                            status: 1
                        }).then((data) => {
                            this.$alert.success({content: '退款成功'});
                            this.$refs.lists.updateData();
                        }).catch((error) => {
                            this.$alert.error({content: '退款失败，请重试：' + error});
                        });
                    }
                });
            },
            releaseEvent(data) {
                this.$api.put('/manage/order_status/' + data.id,{
                    status: 5
                }).then((data) => {
                    this.$alert.success({content: '释放订单成功'});
                }).catch((error) => {
                    this.$alert.error({content: '释放订单失败，请重试'});
                });
            }
        }
    }
</script>

<style scoped>
    .order{
        min-width: 1400px !important;
        padding: 0 5px;
    }
    .order>.header{
        height: 80px;
    }
    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
        padding: 0 5px;
    }
    .filter>div>.select{
        width: 220px;
        border-radius: 3px;
        height: 36px;
        line-height: 36px;
    }
</style>
